import React, {Fragment, useEffect, useState} from "react";
import '../Maintenance/Maintenance.scss'
import SpinnerDiv from "ui/ReactSpinnerDiv";
import TeacherLoadTable, {SIMS_USER_TYPE_STAFF} from "root/s360components/Tables/TeacherLoadTable";
import {getSIMSLatestForSchool} from "root/DataFunctions/SIMSManagerFns";

import useModalLoadSimsTeacher from "root/s360components/Modals/TeacherLoader/useModalLoadSimsTeacher";

import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const TeacherLoadManager = ({enc_school_id}) =>
{
    const EMPTY_DATA = {data: [], isLoading: true};

    const [data, setData] = useState(EMPTY_DATA);

    const [renderModalLoadSimsTeacher, activateModalLoadSimsTeacher] = useModalLoadSimsTeacher();

    const getSimsLatest = () =>
    {
        setData(EMPTY_DATA);

        getSIMSLatestForSchool(enc_school_id, SIMS_USER_TYPE_STAFF, (response) =>
        {
            const recs = getDataFromResponse(response);

            setData({data: recs, isLoading: false});
        })
    }

    useEffect(() =>
    {
        if (enc_school_id !== null)
        {
            getSimsLatest()
        }
    }, [enc_school_id])

    const onClickItem = ({mode, enc_school_id, row}) =>
    {
        activateModalLoadSimsTeacher({mode, enc_school_id, row}).then((result) =>
        {
            if (result !== 'cancel')
            {
                getSimsLatest();
            }
        });
    }

    const noSchoolSelectedSection = () =>
    {
        return (
            <div className='spinner-with-margin'
                 style={{margin: "20px", marginTop: "150px", marginBottom: "150px", textAlign: "center"}}><h4>Please
                select a school</h4>
            </div>
        )
    }

    const loadingSection = () =>
    {
        return (
            <div className='spinner-with-margin'>
                 <SpinnerDiv />
            </div>
        )
    }

    return (
        <Fragment>
            {(enc_school_id !== null && data.isLoading === false) && <TeacherLoadTable enc_school_id={enc_school_id} data={data.data} isLoading={data.isLoading} onClick={onClickItem}/>}
            {(enc_school_id !== null && data.isLoading === true ) && loadingSection()}
            {(enc_school_id === null) && noSchoolSelectedSection()}
            {renderModalLoadSimsTeacher()}
        </Fragment>
    )
}

export default TeacherLoadManager;
